import { iconStyle } from '../shared/stylization';
import { ReactComponent as TollGreen } from '../../icons/toll_green.svg';
import { ReactComponent as TollRed } from '../../icons/toll_red.svg';
import { ReactComponent as ArrowDown } from '../../icons/keyboard_arrow_down.svg';
import { ReactComponent as ArrowUp } from '../../icons/expand_less.svg';
import { useContext, useEffect, useRef, useState } from "react";
import { ClassNameNavbar, Option } from "../shared/navbar/types/navbarProps";
import './onlineField.scss';
import Navbar from "../shared/navbar/navbar";
import AuthContext from "../../contexts/authContext";
import { useClickOutside } from "../../hooks/clickOutsideHook";
import PermissionsContext from '../../contexts/permissionsContext';
import { IsActive } from '../../services/signInService/signInService';
import { apiContext } from '../../contexts/apiContext';
import { notifyWarn } from '../snackbar/snackbar';
import ViewContext from '../../contexts/viewContext';
import ConfirmModal from '../modalWindow/confirmModal';
import InfoModal from '../modalWindow/infoModal';

const OnlineField = () => {
    const { setOnlineMode, onlineMode } = useContext(AuthContext);
    const { functionsPermissions } = useContext(PermissionsContext);
    const [workModeTitle, setWorkModeTitle] = useState('Tryb offline');
    const [menuOpened, setMenuOpened] = useState(false);
    const { apiUrl, apiVersion } = useContext(apiContext);
    const { setViewType, viewTypes, viewType, setKrFormSavePrompt, setKrFormCallback, localView } = useContext(ViewContext);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [information, setInformation] = useState<boolean>(false);

    useEffect(() => {
        onlineMode ? setWorkModeTitle('Tryb offline') : setWorkModeTitle('Tryb online');
        if ((viewType === viewTypes.KRForm || viewType === viewTypes.POForm) && !localView && !confirmation && !onlineMode){
            setInformation(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onlineMode])

    useEffect(() => {

    }, [menuOpened])

    const wrapperRef = useRef<HTMLDivElement>(null);
    useClickOutside(wrapperRef, () => {
        setMenuOpened(false);
    });

    const onlineIcon = () => {
        if (onlineMode) return (<><TollGreen style={iconStyle} /><span className="body-txt-medium">Online</span></>)
        return (<><TollRed style={iconStyle} /><span className="body-txt-medium">Offline</span></>)
    }

    const arrowIcon = () => {
        if (menuOpened) return (<ArrowUp className='onlineExpandLessIcon' style={iconStyle}></ArrowUp>);
        return (<ArrowDown style={iconStyle}></ArrowDown>);
    }

    const onlineToggle: any = () => {
        if (!onlineMode === true) {
            IsActive(apiUrl, apiVersion)?.then((res: any) => {
                setOnlineMode(!onlineMode);
                sessionStorage.setItem("SOPOonline", (!onlineMode).toString());
            }, (reject: any) => {
                if (reject && reject.code && reject.code === "ERR_NETWORK") {
                    notifyWarn({ message: "Brak dostępu do internetu lub serwera, aplikacja pozostanie w trybie offline" });
                } else {
                    setOnlineMode(!onlineMode);
                    sessionStorage.setItem("SOPOonline", (!onlineMode).toString());
                }
            }).catch((error: any) => {
                if (error && error.code && error.code === "ERR_NETWORK") {
                    notifyWarn({ message: "Brak dostępu do internetu lub serwera, aplikacja pozostanie w trybie offline" });
                }
            })
        }
        else {
            if ((viewType === viewTypes.KRForm || viewType === viewTypes.POForm) && !localView) {
                setConfirmation(true);
            } else {
                setOnlineMode(!onlineMode);
                sessionStorage.setItem("SOPOonline", (!onlineMode).toString());
            }
        }
    }

    const changeToOffline = () => {
        setOnlineMode(!onlineMode);
        sessionStorage.setItem("SOPOonline", (!onlineMode).toString());
        setViewType(viewTypes.TaskList);
    }

    const onlineFieldToggle = () => {
        if (!confirmation) {
            setMenuOpened(!menuOpened);
        }
    }

    var navbarOptions: Option[] = [
        { name: workModeTitle, onClick: onlineToggle, disabled: !((onlineMode && functionsPermissions.offlineFunction.active) || (!onlineMode && functionsPermissions.onlineFunction.active)) }
    ]

    const confirm = () => {
        setKrFormSavePrompt(true);
        setConfirmation(false);
        setKrFormCallback(() => changeToOffline);
    }

    const decline = () => {
        setKrFormSavePrompt(false);
        setConfirmation(false);
        changeToOffline();
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        const question = `Przechodzisz w tryb offline podczas edycji karty z poczekalni. Czy chcesz zapisać formularz?`;
        return question;
    }

    const cancelClose = () => {
        setInformation(false);
    }

    return (
        <div onClick={onlineFieldToggle} className="onlineField" ref={wrapperRef} >
            {onlineIcon()}
            {arrowIcon()}
            <Navbar rolledOut={menuOpened} options={navbarOptions} addClass={ClassNameNavbar.menu} style={{ right: '40px' }} />
            {confirmation && <ConfirmModal width={"660px"} height={"auto"}
                confirmTitle={"Tak"}
                onConfirm={confirm}
                cancelTitle={"Anuluj"}
                onCancel={cancel}
                question={getQuestion()}
                onDecline={decline}
                declineTitle="Nie"
            />}
            {information && <InfoModal width={"660px"} height={"auto"}
                cancelTitle={"Zamknij"}
                onCancel={cancelClose}
                information={"Brak dostępu do internetu lub serwera, aplikacja przełączyła się na tryb offline. Aby nie utracić wprowadzonych danych" +
                                    " do karty, poczekaj na dostęp do internetu i spróbuj przełączyć na tryb online."}
            />}
        </div>
    )
}

export default OnlineField;